import React from "react";
import { Spinner } from "./styled";

export function LoadingSpinner(props) {
  return <Spinner {...props} />;
}
